// extracted by mini-css-extract-plugin
export default {"spinner":"NSaZtGrudEzKvRPwdca4","s2":"kbETGrkJjiPUHRNerRlA","spinnerSm":"tyxZxgUcu05CmS1WigqF"};